import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_ENCOUNTER_REQUEST: '',
  GET_ENCOUNTER_SUCCESS: '',
  GET_ENCOUNTER_FAILURE: '',

  SAVE_ENCOUNTER_REQUEST: '',
  SAVE_ENCOUNTER_SUCCESS: '',
  SAVE_ENCOUNTER_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityEncounter');

export default types;
